import React, { useEffect, useState } from "react";
import {graphql} from "react-apollo";
import {connect} from "react-redux";
import gql from "graphql-tag";
import GraphQLErrors from "../../shared/GraphQLErrors";
import AuthenticateStripePayment from "./AuthenticateStripePayment";
import { getStripePublishableKey } from "../../config";
import { Elements } from '@stripe/react-stripe-js';
import {requestShowOrderStatus} from "../../actions/ShopActions";
import { useTranslation } from "react-i18next";
import { loadStripe } from "@stripe/stripe-js";
import LoadingLine from "../../shared/components/forms/LoadingLine";


function AuthenticatePayment(props) {
  const { i18n } = useTranslation("common");

  const [stripePromise, setStripePromise] = useState();

  function handleSuccess() {
    props.requestShowOrderStatus(props.accountId, props.orderId, "verifying");
  }

  function handleError(msg) {
    props.requestShowOrderStatus(props.accountId, props.orderId, "error", msg);    
  }

  const { data } = props;
  const shopId = data?.customerBillingPaymentIntentInfo?.shopId

  useEffect(() => {
    if (shopId) {
      const apiKey = getStripePublishableKey(shopId);
      setStripePromise(loadStripe(apiKey));
    }
  }, [shopId]);

  // We need the shop id to get the stripe promise
  // Stripe promise needs to be set before returning any Stripe Elements
  if (data.loading || !stripePromise) return <LoadingLine />;
  if (data.error) return <GraphQLErrors error={data.error} />

  return (
    <Elements stripe={stripePromise}
      options={{locale: i18n.language}}>
      <AuthenticateStripePayment
        clientSecret={data.customerBillingPaymentIntentInfo.clientSecret}
        onSuccess={handleSuccess}
        onError={handleError}
        />
    </Elements>
  );
}

const QUERY = gql`
  query customerBillingPaymentIntentInfo($accountId:ID!, $salesOrderId:ID!) {
    customerBillingPaymentIntentInfo(accountId: $accountId, salesOrderId: $salesOrderId) {
      clientSecret
      shopId
    }
  }
`;

const withQueries = graphql(QUERY, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      salesOrderId: props.orderId,
      accountId: props.accountId
    }    
  })
});

export default connect(null, {requestShowOrderStatus})(withQueries(AuthenticatePayment));